import { useRef, useState, useEffect, useCallback, useImperativeHandle, forwardRef } from "react";
import "./video-conversation.component.scss";
import LOGO_SO_WATERMARK from "../../assets/images/logo-so-watermark.png";
import LOGO_PROFI from "../../assets/images/water-mark-profi.png";

const VideoConversation = forwardRef(({ isStart, setIsVideoReady, mediaStream, appId }: any, ref) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [stream, setStream] = useState<MediaStream | null>(null);
  const [recordedChunks, setRecordedChunks] = useState<Blob[]>([]);


  useEffect(() => {
    if (mediaStream) {
      console.log(mediaStream);
      setStream(mediaStream);
      startRecording();
    }
  }, [mediaStream]);

  useEffect(() => {
    if (stream) {
      startCamera();
      console.log(stream);
    }
  }, [stream])

  useEffect(() => {
    if (!isStart) {
      stopRecording();
    }
  }, [isStart]);

  useImperativeHandle(ref, () => ({
    takeSnapshot,
    stopRecordingAndReturnBlob,
    stopCamera,  // ✅ Also exposing stopCamera if needed
  }));

  const startCamera = async () => {
    try {
      if (videoRef.current) videoRef.current.srcObject = stream;
      setIsVideoReady(true);
      startRecording();

    } catch (error) {
      console.error("Error accessing camera:", error);
      alert("Failed to access camera. Please check browser permissions. " + error);
    }
  };

  const stopCamera = useCallback(() => {
    stream?.getTracks().forEach((track) => track.stop());
    setStream(null);
  }, [stream]);
  const stopRecording = useCallback(() => {
    mediaRecorderRef.current?.stop();
  }, []);
  const takeSnapshot = useCallback(async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (!video || !canvas) return null;

    const context = canvas.getContext("2d");
    if (!context) return null;

    canvas.width = video.videoWidth || 640;
    canvas.height = video.videoHeight || 480;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const snapshotUrl = canvas.toDataURL("image/png");
    const response = await fetch(snapshotUrl);
    const snapBlob = await response.blob();
    console.log(snapBlob);
    return snapBlob;
  }, []);

  const stopRecordingAndReturnBlob = (): Promise<Blob | null> => {
    return new Promise<Blob | null>((resolve) => {
      const mediaRecorder = mediaRecorderRef.current;

      if (!mediaRecorder) {
        console.error("❌ MediaRecorder is not initialized.");
        resolve(null);
        return;
      }

      const chunks: Blob[] = [];

      // Attach only once
      mediaRecorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          chunks.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        console.log("✅ MediaRecorder stopped");

        if (chunks.length === 0) {
          console.error("❌ No chunks captured. Returning null.");
          resolve(null);
          return;
        }

        // Try creating a Blob with the best supported MIME type
        const supportedTypes = [
          "video/webm;codecs=vp9",
          "video/webm;codecs=vp8",
          "video/webm",
          "video/mp4",
        ];

        let selectedType = supportedTypes.find((type) =>
          MediaRecorder.isTypeSupported(type)
        ) || "video/webm";

        console.log("🎞️ Using MIME type:", selectedType);

        const blob = new Blob(chunks, { type: selectedType });
        console.log("📦 Final blob size:", getBlobSizeInMB(blob), "MB");

        resolve(blob);
        setRecordedChunks([]); // optional cleanup
      };

      try {
        console.log("🛑 Stopping MediaRecorder...");
        mediaRecorder.stop();
      } catch (error) {
        console.error("❌ Error stopping MediaRecorder:", error);
        resolve(null);
      }
    });
  };


  const startRecording = useCallback(() => {
    // if (!stream) return;
    // let options: any = {};
    // if (MediaRecorder.isTypeSupported("video/webm;codecs=vp9")) {
    //   options.mimeType = "video/webm;codecs=vp9";
    // } else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp8")) {
    //   options.mimeType = "video/webm;codecs=vp8";
    // } else if (MediaRecorder.isTypeSupported("video/webm")) {
    //   options.mimeType = "video/webm";
    // } else if (MediaRecorder.isTypeSupported("video/mp4")) {
    //   // Note: This may not actually work — iOS doesn't support this for MediaRecorder
    //   options.mimeType = "video/mp4";
    // } else {
    //   console.warn("No supported video mimeType found for MediaRecorder.");
    // }

    // // Create recorder only if supported
    // let mediaRecorder;
    // try {
    //   mediaRecorder = new MediaRecorder(stream, options);
    // } catch (e) {
    //   console.error("MediaRecorder is not supported on this device.", e);
    // }
    // console.log("Recording Video");

    // let chunks: Blob[] = []; // Use a local variable to store chunks

    // mediaRecorder.ondataavailable = (event) => {
    //   if (event.data.size > 0) {
    //     chunks.push(event.data);
    //   }
    // };

    // mediaRecorder.onstop = () => {
    //   console.log("✅ Video recording stopped.");
    //   setRecordedChunks(chunks); // Store recorded chunks when stopping
    //   setIsVideoReady(true);
    // };

    // mediaRecorderRef.current = mediaRecorder;
    // mediaRecorder.start();
  }, [stream]);



  const getBlobSizeInMB = (blob: Blob) => {
    return (blob.size / (1024 * 1024)).toFixed(2) + " MB";
  };

  return (
    <div className="video-comp-control">
      <div className="video-comp-border">
        <div className="video-comp-border-inside">
          {
            appId == "SCOUTOUT" ?
              <img src={LOGO_SO_WATERMARK} className="watermark"></img> :
              appId == "PROFI" ?
              <img src={LOGO_PROFI} className="watermark-custom"></img> :
              <></>
          }
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{
              width: "100%",
              objectFit: "cover",
              borderRadius: "24px",
              transform: "scaleX(-1)",
            }}
          />
          <canvas ref={canvasRef} style={{ display: "none" }} width="100%" height="0"></canvas>
        </div>
      </div>
    </div>
  );
});


export default VideoConversation;
